import {EventEmitter, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {tap} from "rxjs/operators";
import {Database} from "../../models/database";
import {Project} from "../../models/project";
import {Structure} from "../../models/structure";

@Injectable({
  providedIn: 'root'
})
export class DatabaseService {

  private readonly DATABASE_ID = 'DATABASE_ID';
  private readonly DATABASE_LANG = 'DATABASE_LANG';
  private readonly DATABASE_CODE = 'DATABASE_CODE';

  public database: Database;
  public databases: Array<Database> = [];
  public onSelect: EventEmitter<string> = new EventEmitter<string>();
  public onChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private http: HttpClient,
  ) {
  }

  getAllMyDatabases(projectId) {
    return this.http.get('/api/v1/projects/' + projectId + '/databases').pipe(
      tap(data => this.databases = data['data']['databases'].map(database => new Database(database)))
    )
  }

  postDatabase(projectId, database: Database) {
    return this.http.post('/api/v1/projects/' + projectId + '/databases', database.getObj()).pipe(
      tap(
        data => this.databases.push(new Database(data['data']['database'])),
        err => console.error(err)
      )
    );
  }

  getSingleDatabase(projectId, databaseId) {
    return this.http.get('/api/v1/projects/' + projectId + '/databases/' + databaseId).pipe(
      tap(
        data => {
          this.database = new Database(data['data']['database']);

          const index = this.databases.findIndex(m => m["_id"] === this.database._id);

          if (index > -1)
            this.databases[index] = this.database;
          else
            this.databases.push(this.database);

        },
        err => console.error(err)
      )
    );
  }

  patchDatabase(projectId, databaseId, database: Database) {
    return this.http.patch('/api/v1/projects/' + projectId + '/databases/' + databaseId, database.getObj()).pipe(
      tap(
        data => {
          this.database = new Database(data['data']['database']);

          const index = this.databases.findIndex(db => db["_id"] === databaseId);

          if (index > -1)
            this.databases[index] = this.database;
          else
            this.databases.push(this.database);

          this.onChange.emit(true);
        },
        err => console.error(err)
      )
    );
  }

  deleteDatabase(projectId, databaseId) {
    return this.http.delete('/api/v1/projects/' + projectId + '/databases/' + databaseId).pipe(
      tap(
        () => {
          this.databases.splice(this.databases.findIndex(m => m["_id"] === databaseId), 1);
        },
        err => console.error(err)
      )
    );
  }

  cloneDatabase(projectId, databaseId, database: Database) {
    return this.http.post('/api/v1/projects/' + projectId + '/databases/' + databaseId + '/clone', database.getObj()).pipe(
      tap(
        data => this.databases.push(new Database(data['data']['database'])),
        err => console.error(err)
      )
    );
  }

  patchStructure(projectId, databaseId, structure: Structure) {
    return this.http.patch('/api/v1/projects/' + projectId + '/databases/' + databaseId + '/structure', structure.getObj(false)).pipe(
      tap(
        data => {
          this.database = new Database(data['data']['database']);

          const index = this.databases.findIndex(d => d["_id"] === databaseId);

          if (index > -1)
            this.databases[index] = this.database;

          this.onChange.emit(true);

        },
        err => console.error(err)
      )
    );
  }
}
